import React from 'react';
import dateformat from 'dateformat';

import compareDates from '@ibibo/date-utils/src/compareDates';
import isDateEqual from '@ibibo/date-utils/src/isDateEqual';
import IconSelector from '@ibibo/icon-selector';

import * as S from './TripBookingCard.styles';

const TripBookingCard = ({bookingDetail, navigateToMyTripsDetails}) => {
    const {amount, booking_id, hotel_city, hotel_name, rating, status_text, trip_type, payment_id, mobile, trip_actions = []} = bookingDetail;

    const {travel_start_datetime, travel_end_datetime, rooms, room_night, name, no_of_guest, vendor_fcdt, image} = bookingDetail;

    const checkin = new Date(travel_start_datetime.replace(/ /g,"T"));
    const checkout = new Date(travel_end_datetime.replace(/ /g,"T"));

    const today = new Date();

    // active trip
    // if checkin is today or before today && checkout is today or after today
    // checkin <= today && checkout >= today
    let isActive = false;
    if ((!compareDates(checkin, today) || isDateEqual(checkin, today)) && (compareDates(checkout, today) || isDateEqual(checkin, today))) {
      isActive = true;
    }

    let paxText = `${no_of_guest.adults} Adults`;
    if (no_of_guest.child) {
      paxText += ` | ${no_of_guest.child} Child${no_of_guest.child > 1 ? 'ren' : ''}`;
    }

    return(
        <S.MyBookingsInnerWrap>
            <S.MyBookingsCardWrap>
              {isActive ? <S.TripActiveStatusWrap isActive={isActive}>
                <S.TripActiveStatusText>Active Trip</S.TripActiveStatusText>
              </S.TripActiveStatusWrap> : <S.TripStatusWrap>
                <S.TripStatusText>{dateformat(checkin, 'dd')}<span>{dateformat(checkin, 'mmm')}</span></S.TripStatusText>
              </S.TripStatusWrap>}
              <S.TripDestInfoWrap>
                <S.TripDestInfoText>{hotel_name}</S.TripDestInfoText>
                <S.TripDestCityText>{hotel_city}</S.TripDestCityText>
              </S.TripDestInfoWrap>
              <S.TripInfoWrapper>
                <S.TripInfoHeadText>Check-in</S.TripInfoHeadText>
                <S.TripInfoDateText>{dateformat(checkin, 'dd mmm \'yy')}</S.TripInfoDateText>
                <S.TripInfoPaxText>{dateformat(checkin, 'shortTime')}</S.TripInfoPaxText>
              </S.TripInfoWrapper>
              <S.TripInfoWrapper>
                <S.TripInfoHeadText>Check-Out</S.TripInfoHeadText>
                <S.TripInfoDateText>{dateformat(checkout, 'dd mmm \'yy')}</S.TripInfoDateText>
                <S.TripInfoPaxText>{dateformat(checkout, 'shortTime')}</S.TripInfoPaxText>
              </S.TripInfoWrapper>
              <S.TripInfoWrapper>
                <S.TripInfoHeadText>Guest Detail</S.TripInfoHeadText>
                <S.TripInfoDateText>{name}</S.TripInfoDateText>
                <S.TripInfoPaxText>{paxText}</S.TripInfoPaxText>
              </S.TripInfoWrapper>
              <S.TripDetailWrap>
                <S.TripDetailText onClick={() => {
                  navigateToMyTripsDetails(`${payment_id}_${mobile}`);
                }}>See details</S.TripDetailText>
              </S.TripDetailWrap>
            </S.MyBookingsCardWrap>
            {(trip_actions.length && <S.MyBookingActionsWrap>
              {(trip_actions.map(item => <S.ActionsInnerWrap key={item.icon}>
                <S.ActionIconWrap>
                  <IconSelector iconKey={item.icon} />
                </S.ActionIconWrap>
                <S.ActionText href={item.link}>{item.title}</S.ActionText>
              </S.ActionsInnerWrap>))}
            </S.MyBookingActionsWrap>) || null}
        </S.MyBookingsInnerWrap>
    );
}

export default TripBookingCard;